/*global angular */

(function (angular) {
    angular.module('comments', ['ngCookies'])
        .controller('CommentsController', [
            '$scope', '$http', '$cookies', '$window',
            function ($scope, $http, $cookies, $window) {
                $scope.comments = $window.comments;
                $scope.is_javascript_enable = true;
            }]);

}(angular));
